/**
 * Every avatar the app draws, at the size it is drawn.
 *
 * profiles.avatar_url points at the original upload. Some originals are
 * phone photos of several megabytes (one is 9 MB), and the community feed,
 * the member map, the tag list and the leaderboard all draw avatars at
 * 30 to 80 px. Supabase Storage renders a resized copy of any public object
 * on request (/render/image/), so a 9 MB original arrives as a few KB.
 * Checked against production on 2026-10-07: 16.7 KB original, 3.2 KB at 96 px.
 *
 * Only Supabase Storage public URLs are rewritten. Anything else (an OAuth
 * avatar, a URL from elsewhere) passes through. A data: URL, a photo stored
 * inline in the row, returns null so the caller shows initials rather than
 * painting a multi-megabyte string: that is what made the feed take thirty
 * seconds, and the database now refuses new ones.
 *
 * No em dashes.
 */

const OBJECT = "/storage/v1/object/public/";
const RENDER = "/storage/v1/render/image/public/";

/** `px` is the drawn size; it is doubled for retina screens. */
export function avatarSrc(url, px = 80) {
  if (!url || typeof url !== "string") return null;
  if (url.startsWith("data:")) return null;
  const i = url.indexOf(OBJECT);
  if (i === -1) return url;
  const size = Math.max(16, Math.min(1024, Math.round(px * 2)));
  const [path, query] = url.slice(i + OBJECT.length).split("?");
  const params = new URLSearchParams(query || "");
  params.set("width", String(size));
  params.set("height", String(size));
  params.set("resize", "cover");
  params.set("quality", "70");
  return `${url.slice(0, i)}${RENDER}${path}?${params.toString()}`;
}
